export enum ErrorResource {
  CREATE_AGENT = 'CREATE_AGENT',
  DIRECT_MATCH_POST = 'DIRECT_MATCH_POST',
  MAP_GET_LOCATION_RESPONSE = 'MAP_GET_LOCATION_RESPONSE',
  MAP_RUN_ADDRESS_REQUEST = 'MAP_RUN_ADDRESS_REQUEST',
  MAP_GET_PRE_SIGNED_URLS = 'MAP_GET_PRE_SIGNED_URLS',
}
